<div class="mt-5" *ngIf="thresholds">
  <div class="col-12 col-md-11 mx-auto">
    <div class="bg-white rounded-5 shadow p-4 p-md-5" id="print">
      <div
        class="threshold-card"
        *ngFor="let threshold of thresholds"
        [ngClass]="{
          'level-0': threshold.level === 0,
          'level-1': threshold.level === 1,
          'level-2': threshold.level === 2
        }">
        <span class="material-icons threshold-icon level-2-icon" *ngIf="threshold.level === 2">cancel</span>
        <span class="material-icons-outlined threshold-icon level-1-icon" *ngIf="threshold.level === 1">warning</span>
        <span class="material-icons-outlined threshold-icon level-0-icon" *ngIf="threshold.level === 0">check_circle</span>
        <div class="threshold-body">
          <p class="threshold-title">{{ threshold.questionGroupName }}</p>
          <p class="threshold-content" [innerHTML]="threshold.content"></p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mt-5">
  <div class="col-12 col-md-3 text-center text-md-left d-flex justify-content-end flex-column">
    <button class="btn btn-lg btn-white bg-white mb-5 mx-auto rounded shadow text-black px-4" (click)="print()">Imprimer</button>
  </div>
  <div class="col-12 col-md-9" *ngIf="!login && answers">
    <div class="my-5 text-center">
      <p translate>Tu peux créer un compte anonyme afin de sauvegarder tes résultats</p>
      <button class="btn btn-lg btn-info text-white mx-auto mt-3 rounded shadow px-4" (click)="openModalSignup()" translate>Créer un compte</button>
    </div>
  </div>
</div>
